import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente ModalBox
 */
export const ModalBox = styled.div`
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  padding: 40px;
  box-sizing: border-box;
  outline: 0;
  padding-top: 20px;
  /* padding-bottom: 90px; */
  padding-bottom: 30px;
  width: 387px;

  header {
    border-bottom: 1px solid #e6e6e6;

    h2 {
      font-family: Roboto;
      font-size: 16px;
      font-weight: 300;
      line-height: 19px;
      letter-spacing: 0em;
      color: #5E6366;

      margin-bottom: 10px;
    }
  }

  footer {    
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
  }

  p {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
    color: #5E6366;
  }

  .close {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }
`;

/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    width: 85.91px;
    height: 32px;

    margin-top: 10px;
  }

  &.MuiButton-contained {
    box-shadow: none;
  }

  &.MuiButton-containedPrimary {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    border-radius: 3px;
    text-align: center;

    color: #fff;
    background-color: #3C71DD;
  }
`;
